import React from 'react';
import { Grid, Card, CardContent, Typography, Fade } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  background: theme.palette.mode === 'light'
    ? '#FFFFFF'
    : 'linear-gradient(145deg, #121212 0%, #1a1a1a 100%)',
  boxShadow: theme.palette.mode === 'light'
    ? '0 4px 20px 0 rgba(0, 0, 0, 0.1)'
    : '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
  border: theme.palette.mode === 'light'
    ? '1px solid rgba(0, 0, 0, 0.1)'
    : '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '16px',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.palette.mode === 'light'
      ? '0 8px 24px 0 rgba(0, 0, 0, 0.15)'
      : '0 12px 40px 0 rgba(0, 0, 0, 0.4)',
  },
}));

const GradientText = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 700,
}));

const SummaryCards = ({ chartData }) => {
  const cards = [
    {
      title: 'Total de Registros',
      value: chartData.total,
      color: 'primary',
    },
    {
      title: 'Pendentes',
      value: chartData.pendentes,
      color: 'warning',
    },
    {
      title: 'Aprovados',
      value: chartData.aprovados,
      color: 'success',
    },
    {
      title: 'Reprovados',
      value: chartData.reprovados,
      color: 'error',
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid key={index} sx={{ width: { xs: '100%', sm: '50%', md: '25%' } }}>
          <Fade in timeout={500} style={{ transitionDelay: `${index * 100}ms` }}>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'text.secondary',
                    mb: 1,
                    fontWeight: 500,
                  }}
                >
                  {card.title}
                </Typography>
                <GradientText variant="h4">
                  {card.value}
                </GradientText>
              </CardContent>
            </StyledCard>
          </Fade>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCards;